import styled from 'styled-components';

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-top: ${({ withTopMargin, theme }) =>
    withTopMargin ? theme.spacing(6) : theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(6)};
  margin-left: ${({ withLeftMargin, theme }) =>
    withLeftMargin && theme.spacing(6)};
  background: ${({ theme }) => theme.colors.white};
`;

export default SearchContainer;
